import { ChevronDown } from "@/components/icons/ChevronDown";
import type { dayjs } from "@/lib/dayjs";
import { type Dispatch, type SetStateAction, useState } from "react";

type Props = {
  allDates: Array<dayjs.Dayjs>;
  dates: Array<dayjs.Dayjs>;
  setDates: Dispatch<SetStateAction<Array<dayjs.Dayjs>>>;
};
export const Months = ({ allDates, dates, setDates }: Props) => {
  const [open, setOpen] = useState(false);

  const handleClick = (date: dayjs.Dayjs) => {
    if (dates.some((d) => d.isSame(date, "year") && d.isSame(date, "month"))) {
      setDates(dates.filter((v) => !(v.isSame(date, "year") && v.isSame(date, "month"))));
    } else {
      setDates([...dates, date]);
    }
    setOpen(false);
  };

  return (
    <div className="flex relative select-none">
      <div
        className="text-pr-1 border-2 border-pr-1 uppercase font-semibold flex items-center py-1 px-8 cursor-pointer"
        onClick={() => setOpen(!open)}
      >
        Calendrier
        <ChevronDown className="w-5 h-5 ml-2 shrink-0" />
      </div>
      {open && (
        <div className="bg-white shadow-md p-4 top-full left-0 absolute mt-4 z-10 w-52 max-h-64 overflow-y-auto">
          {allDates.map((d, i) => (
            <>
              <div
                className="flex cursor-pointer text-base leading-5 text-primary capitalize"
                onClick={() => handleClick(d)}
              >
                <div className="w-[18px] h-[18px] border border-pr-1 mr-3">
                  {dates.some((date) => date.isSame(d, "year") && date.isSame(d, "month")) && (
                    <div className="bg-pr-1 w-3 h-3 mt-0.5 ml-0.5" />
                  )}
                </div>
                {d.format("MMMM YYYY")}
              </div>
              {i < allDates.length - 1 && <div className="border-[0.5px] border-pr-1 my-3" />}
            </>
          ))}
        </div>
      )}
    </div>
  );
};
